import type { PatientResponse } from '../../../api/generated';
import type { RoomProperty } from '../../../store/roomProperties/roomPropertiesSlice';

export interface FormState {
  name: string;
  cpr: string;
  email: string;
  phone: string;
  comment: string;
  roomNeeds: RoomProperty[];
}

export const emptyForm: FormState = {
  name: '',
  cpr: '',
  email: '',
  phone: '',
  comment: '',
  roomNeeds: []
};

export const formFromPatient = (
  patient: PatientResponse,
  roomNeeds: RoomProperty[]
): FormState => ({
  name: patient.name,
  cpr: patient.cprNumber,
  email: patient.email ?? '',
  phone: patient.phoneNumber ?? '',
  comment: patient.note ?? '',
  roomNeeds
});

export type PatientCreatePrefill = { name: string } | { cpr: string };

export interface PatientDetailsCardProps {
  patient?: PatientResponse | null;
  locationId: string;
  mode: 'view' | 'edit' | 'create';
  createPrefill?: PatientCreatePrefill;
  onEditStart: () => void;
  onEditEnd: () => void;
  onPatientUpdated?: () => void;
  onPatientCreated?: (created: PatientResponse) => void | Promise<void>;
}
